export default __webpack_public_path__ + "images/9babb6ab7bb8068158af0d9a27a01f25-getDiscovered.webp";